<script>
import PopinAnchor from "@/components/molecules/popin-anchor";
import MenuLayer from "@/components/organisms/header/menu/menu-layer/default";
import ListItem from "@/components/molecules/list/list-item";
import Icon from "@/components/atoms/icon";
import menuCodes from "@/utils/menu-codes";

export default {
  name: "MenuItem",
  components: {
    PopinAnchor,
    MenuLayer,
    ListItem,
    Icon
  },
  props: {
    category: {
      type: Object,
      required: true
    },
    main: {
      type: Boolean,
      required: false,
      default: false
    },
    useVshow: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      isSelected: false,
      menuCodes
    };
  },
  computed: {},
  methods: {
    closed() {
      this.isSelected = false;
      // A voir si c'est bien le comportement qu'on souhaite
      if (this.useVshow && this.$refs.layer) {
        this.$refs.layer.reset();
      }
    },
    hide() {
      this.$refs.popin.close();
    }
  }
};
</script>

<template>
  <ListItem class="c-header-menu__nav-list-item">
    <template v-if="category.attributes.children && category.attributes.children.data.length > 0">
      <PopinAnchor
        ref="popin"
        shadow="lg"
        size="md"
        :variant="main ? 'primary' : null"
        menu-item
        open-on-hover
        :main-menu="!main"
        show-close-button
        class="c-header-menu__popin-anchor"
        button-class="c-button--menu-button"
        :use-vshow="useVshow"
        :hover-delay="200"
        @opened="isSelected = true"
        @closed="closed()"
      >
        <template #button-content>
          <Icon
            v-if="main"
            name="basket"
            variant="white"
            size="sm"
            class="u-mr-xs"
          />
          {{ category.attributes.libelle }}
        </template>
        <MenuLayer
          ref="layer"
          :category="category"
          :brands="category.attributes.marques"
        />
      </PopinAnchor>
    </template>
  </ListItem>
</template>

<style scoped lang="scss">
.c-header-menu__popin-anchor {
  height: 100%;
  .c-button {
    height: 100%;
  }
}
</style>
